import { IQuery } from "./IQuery";

export default class OrQuery implements IQuery {
  SEPARATOR = "||";
  private queries: IQuery[];

  constructor(queries: IQuery[]) {
    this.queries = queries;
  }

  buildQueryString() {
    return this.queries
      .map((it) => it.buildQueryString())
      .filter((x) => x)
      .join(this.SEPARATOR);
  }
}
